/** PayMongo publishable key (`pk_test_*` / `pk_live_*`) — safe in the browser bundle. */

export function paymongoPublishableKey(): string | undefined {
  const k = typeof import.meta !== 'undefined' ? import.meta.env?.VITE_PAYMONGO_PUBLIC_KEY : undefined;
  return typeof k === 'string' && k.trim() ? k.trim() : undefined;
}
